
import PersonalDetailEditor from "./PersonalDetailEditor";
import ProductInstanceViewer from "./ProductInstanceViewer";
import AccountSidebar from "./AccountSidebar";

export default {
    PersonalDetailEditor,
    ProductInstanceViewer,
    AccountSidebar,
}